import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription, filter, take } from 'rxjs';
import { DialogsManagerService } from 'src/shop-manager/services/dialogs-manager.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ClinicTypesEnum } from 'src/shop-manager/common/enums/clinic-types-enum';
import { ClinicOfficeManageService } from 'src/shop-manager/services/clinic-office-manage.service';
import { CountriesEnum } from 'src/common-panel/enums/countries-enum';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { UsaStatesEnum } from 'src/shop-manager/common/enums/usa-states-enum';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';
import { BrandTypesEnum } from 'src/common-panel/enums/brand-types-enum';
import { CrmTypesEnum } from 'src/common-panel/enums/crm-types-enum';
import { COUNTRIES_IDS, CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
    selector: 'app-edit-clinic-office-dialog',
    templateUrl: './edit-clinic-office-dialog.component.html',
    styleUrls: ['./edit-clinic-office-dialog.component.css'],
    standalone: false
})
export class EditClinicOfficeDialogComponent implements OnInit
{
  subscription: Subscription = new Subscription()


  form: FormGroup = new FormGroup({
    country: new FormControl({ value: '', disabled: true }, [Validators.required]),
    show: new FormControl(true),
    type1: new FormControl({ value: '', disabled: true }, [Validators.required]),
    type2: new FormControl({ value: ClinicTypesEnum.physical, disabled: true }, [Validators.required]),
    name: new FormControl('', [Validators.required, Validators.pattern("^[^<>\"'`{}()$]*$")]),
    clinicOfficeId: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.pattern("^[^<>\"'`{}()$]*$")]),
    coordinates: new FormControl('', [Validators.required, Validators.pattern("^[-]?[0-9]+[\.][0-9]+,[ \s]*[-]?[0-9]+[\.][0-9]+$")]),
    city: new FormControl('', [Validators.required, Validators.pattern("^[^<>\"'`{}()$]*$")]),
    addressLine1: new FormControl('', [Validators.required, Validators.pattern("^[^<>\"'`{}()$]*$")]),
    addressLine2: new FormControl('',[ Validators.pattern("^[^<>\"'`{}()$]*$")]),
    zipCode: new FormControl('', [Validators.required, Validators.pattern("^[^<>\"'`{}()$]*$")]),
    phone: new FormControl('',[Validators.pattern('^[-–()0-9 +]*$')]),
    website: new FormControl('', Validators.pattern("^[^<>\"'`{}()$]*$")),
    state: new FormControl('', Validators.pattern("^[^<>\"'`{}()$]*$")),
    email: new FormControl('', [Validators.pattern("(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+(\\.[a-zA-Z]{2,7})+$)|–")]),
    crm: new FormControl(''),
    entNames: new FormArray([
      
    ])
  })

  week = new FormGroup({
    monday: new FormArray<FormGroup<{ start: FormControl<any>; end: FormControl<any>; }>>([]),
    tuesday: new FormArray<FormGroup<{ start: FormControl<any>; end: FormControl<any>; }>>([]),
    wednesday: new FormArray<FormGroup<{ start: FormControl<any>; end: FormControl<any>; }>>([]),
    thursday: new FormArray<FormGroup<{ start: FormControl<any>; end: FormControl<any>; }>>([]),
    friday: new FormArray<FormGroup<{ start: FormControl<any>; end: FormControl<any>; }>>([]),
    saturday: new FormArray<FormGroup<{ start: FormControl<any>; end: FormControl<any>; }>>([]),
    sunday: new FormArray<FormGroup<{ start: FormControl<any>; end: FormControl<any>; }>>([]),
  })

  Object = Object

  ShopTypesEnum = ShopTypesEnum
  ClinicTypesEnum = ClinicTypesEnum
  CountriesEnum = CountriesEnum
  BrandTypesEnum = BrandTypesEnum
  CountriesIDs = COUNTRIES_IDS
  UsaStatesEnum = UsaStatesEnum

  isUs: boolean = false
  isOffice: boolean = false
  isPhysical: boolean = true

  dirty: boolean = false

  constructor(private dialogRef: MatDialogRef<any>, private serverValueInterpreterService: ServerValueInterpreterService,
    private dialogsManagerService: DialogsManagerService, private clinicOfficeManageService: ClinicOfficeManageService)
  {
  }

  ngOnInit(): void
  {

    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() =>
    {
      this.clinicOfficeManageService.clearAll()
    })

    let l_sub = this.form.controls['type1'].valueChanges.subscribe(() =>
    {
      if (this.form.controls['type1'].value == ShopTypesEnum.clinic)
      {

        this.isOffice = false
      } else
      {
        this.isOffice = true
      }
    })

    let l_sub1 = this.form.controls['type2'].valueChanges.subscribe(() =>
    {
      if (this.form.controls['type2'].value == ClinicTypesEnum.physical)
        {
          this.isPhysical = true
          this.form.controls['coordinates'].setValidators([Validators.required,Validators.pattern("^[^<>\"'`{}()$]*$")])
          this.form.controls['city'].setValidators([Validators.required,Validators.pattern("^[^<>\"'`{}()$]*$")])
          this.form.controls['addressLine1'].setValidators([Validators.required,Validators.pattern("^[^<>\"'`{}()$]*$")])
          this.form.controls['zipCode'].setValidators([Validators.required,Validators.pattern("^[^<>\"'`{}()$]*$")])
          this.form.controls['coordinates'].updateValueAndValidity();
          this.form.controls['city'].updateValueAndValidity();
          this.form.controls['addressLine1'].updateValueAndValidity();
          this.form.controls['zipCode'].updateValueAndValidity();
        } else
        {
          this.isPhysical = false
          this.form.controls['show'].setValue(false)
          this.form.controls['coordinates'].clearValidators();
          this.form.controls['coordinates'].updateValueAndValidity();
          this.form.controls['city'].clearValidators();
          this.form.controls['city'].updateValueAndValidity();
          this.form.controls['addressLine1'].clearValidators();
          this.form.controls['addressLine1'].updateValueAndValidity();
          this.form.controls['zipCode'].clearValidators();
          this.form.controls['zipCode'].updateValueAndValidity();
        }
    })

    let l_sub2 = this.form.controls['country'].valueChanges.subscribe(() =>
    {
      if (this.form.controls['country'].value.toString() == "US")
      {
        this.isUs = true

        this.form.controls['crm'].setValidators(Validators.required)
      } else
      {
        this.isUs = false
        this.form.controls['crm'].clearValidators();
        this.form.controls['crm'].updateValueAndValidity();
      }
    })

    let l_sub3 = this.clinicOfficeManageService.coordinatesToUpdate.pipe(filter(val => val == true)).subscribe(() =>
    {
      this.updateCoordinates()
      this.dirty = true
      this.clinicOfficeManageService.coordinatesToUpdate.next(false)
    })

    this.setValuesFromModel()
    this.subscription.add(l_sub)
    this.subscription.add(l_sub1)
    this.subscription.add(l_sub2)
    this.subscription.add(l_sub3)
  }

  setValuesFromModel()
  {
    this.form.controls['country'].setValue(this.clinicOfficeManageService.currentClinicOffice?.countryId)
    this.form.controls['show'].setValue(this.clinicOfficeManageService.currentClinicOffice?.shown)
    this.form.controls['type1'].setValue(this.clinicOfficeManageService.currentClinicOffice?.type1)
    this.form.controls['type2'].setValue(this.clinicOfficeManageService.currentClinicOffice?.shopType)
    this.form.controls['clinicOfficeId'].setValue(this.clinicOfficeManageService.currentClinicOffice?.clinicOfficeId)
    this.form.controls['name'].setValue(this.clinicOfficeManageService.currentClinicOffice?.name)
    if (this.clinicOfficeManageService.currentClinicOffice?.email) this.form.controls['email'].setValue(this.clinicOfficeManageService.currentClinicOffice?.email)
    if (this.clinicOfficeManageService.currentClinicOffice?.phone) this.form.controls['phone'].setValue(this.clinicOfficeManageService.currentClinicOffice?.phone)
    if (this.clinicOfficeManageService.currentClinicOffice?.website) this.form.controls['website'].setValue(this.clinicOfficeManageService.currentClinicOffice?.website)
    this.form.controls['crm'].setValue(this.clinicOfficeManageService.currentClinicOffice?.crmType)

    this.form.controls['coordinates'].setValue(this.clinicOfficeManageService.currentClinicOffice?.geolocation.latitude + ', ' + this.clinicOfficeManageService.currentClinicOffice?.geolocation.longitude)
    this.form.controls['city'].setValue(this.clinicOfficeManageService.currentClinicOffice?.city)
    this.form.controls['addressLine1'].setValue(this.clinicOfficeManageService.currentClinicOffice?.addressLine1)
    this.form.controls['addressLine2'].setValue(this.clinicOfficeManageService.currentClinicOffice?.addressLine2)
    this.form.controls['zipCode'].setValue(this.clinicOfficeManageService.currentClinicOffice?.zipCode)
    this.form.controls['state'].setValue(this.clinicOfficeManageService.currentClinicOffice?.state)

    let l_week = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]
    this.clinicOfficeManageService.currentClinicOffice?.openingHours.forEach((day, index) =>
    {
      day.forEach(time =>
      {
        if (time.split('-').length > 1)
        {
          let l_start = time.split('-')[0].split(' ').join('')
          let l_end = time.split('-')[1].split(' ').join('')
          this.addTimeToDay(l_week[index], l_start, l_end)
        }
      });

    });

    if (this.clinicOfficeManageService.currentClinicOffice?.type1 == ShopTypesEnum.entOffice && this.clinicOfficeManageService.currentClinicOffice?.doctors)
    {
      this.clinicOfficeManageService.currentClinicOffice?.doctors.forEach((doctor, index) =>
      {
       
          if (doctor.split(' ').length > 1)
          {
            let l_firstName = doctor.split(' ')[0]
            let l_lastName = doctor.split(' ')[1]
            this.addToEntNames( l_firstName, l_lastName)
          }
        });

     
    }

  }

  isDeletable(): boolean
  {
    return (this.clinicOfficeManageService.currentClinicOffice?.patientsAmount != undefined && !(this.clinicOfficeManageService.currentClinicOffice?.patientsAmount > 0)) && (this.clinicOfficeManageService.currentClinicOffice?.hcpAmount != undefined && !(this.clinicOfficeManageService.currentClinicOffice?.hcpAmount > 0) && (this.clinicOfficeManageService.currentClinicOffice?.entAmount != undefined && !(this.clinicOfficeManageService.currentClinicOffice?.entAmount > 0)))
  }

  ngOnDestroy(): void
  {
    this.subscription.unsubscribe()
  }

  getCRMNameByNumber(crmNumber: number): CrmTypesEnum | undefined
  {
    return this.serverValueInterpreterService.getCRMNameByNumber(crmNumber)
  }

  getEntNames(): FormArray
  {
    return this.form.get("entNames") as FormArray
  }

  removeEntName(index: number)
  {
    this.getEntNames().removeAt(index);
  }

  addToEntNames(firstName: string ='', lastName: string='')
  {
    
    let newEntName =     
      new FormGroup({
        firstName: new FormControl(firstName, [
          Validators.pattern("^[^<>\"'`{}()$]*$") 
        ]),
        lastName: new FormControl(lastName, [
          Validators.pattern("^[^<>\"'`{}()$]*$") 
        ])
      })
    
    this.getEntNames().push(newEntName)
    return
  }


  getDay(day: string): FormArray
  {
    return this.week.get(day) as FormArray
  }

  getFormGroup(controlGroup: any)
  {
    return controlGroup as FormGroup
  }

  addTimeToDay(day: string, start: string ='', end: string='')
  {
    let newPeriod = new FormGroup({
      start: new FormControl(start, [Validators.required]),
      end: new FormControl(end, [Validators.required]),
    });

    this.getDay(day).push(newPeriod)
  }

  removeFromDay(day: string)
  {
    this.getDay(day).removeAt(Object.keys(this.getDay(day).controls).length - 1)
  }

  updateCoordinates()
  {
    this.form.controls['addressLine1'].setValue(this.clinicOfficeManageService.address?.addressLine1)
    this.form.controls['addressLine2'].setValue(this.clinicOfficeManageService.address?.addressLine2)
    this.form.controls['coordinates'].setValue(this.clinicOfficeManageService.address?.latitude + ', ' + this.clinicOfficeManageService.address?.longitude)
    this.form.controls['city'].setValue(this.clinicOfficeManageService.address?.city)
    this.form.controls['state'].setValue(this.clinicOfficeManageService.address?.state)
    this.form.controls['zipCode'].setValue(this.clinicOfficeManageService.address?.zipCode)
  }

  fillModel()
  {
    let l_latitude = this.isPhysical ? (this.form.controls['coordinates'].value as String).split(',')[0].split(" ").join("") : '0.0'
    let l_longitude = this.isPhysical ? (this.form.controls['coordinates'].value as String).split(',')[1].split(" ").join("") : '0.0'
    this.clinicOfficeManageService.editedClinicOffice = {
      email: this.form.controls['email'].value.length > 0 ? this.form.controls['email'].value : '–',
      state: this.form.controls['state'].value,
      zipCode: this.form.controls['zipCode'].value,
      phone: this.form.controls['phone'].value.length > 0 ? this.form.controls['phone'].value : '–',
      crmType: this.form.controls['crm'].value,
      website: this.form.controls['website'].value.length > 0 ? this.form.controls['website'].value : '–',
      openingHours: this.convertHoursToArray(),
      geolocation: {
        longitude: l_longitude,
        latitude: l_latitude
      },
      shopType: this.form.controls['type2'].value,
      brand: !this.isOffice ? this.serverValueInterpreterService.getBrandIdByCountryId(this.form.controls['country'].value) : undefined,
      city: this.form.controls['city'].value,
      clinicOfficeId: this.form.controls['clinicOfficeId'].value,
      shown: this.form.controls['show'].value,
      countryId: this.form.controls['country'].value,
      addressLine1: this.form.controls['addressLine1'].value,
      addressLine2: this.form.controls['addressLine2'].value,
      name: this.form.controls['name'].value,
      type1: this.form.controls['type1'].value,
      doctors:this.convertDoctorsToArray()
    }

  }

  convertDoctorsToArray(): string[]
  {
    let l_result: string[]= []
    this.form.controls['entNames'].value.forEach((name:{ firstName: FormControl<any>; lastName: FormControl<any>; }) =>
    {
      if(name.firstName.toString().length>0 ||name.lastName.toString().length>0)
      l_result.push(name.firstName + ' ' + name.lastName)
    });
    return l_result
  }


  convertHoursToArray(): string[][]
  {
    let l_result: string[][] = [[], [], [], [], [], [], []]

    this.week.controls.monday.value.forEach(element =>
    {
      l_result[0].push(element.start + ' - ' + element.end)
    });
    this.week.controls.tuesday.value.forEach(element =>
    {
      l_result[1].push(element.start + ' - ' + element.end)
    });
    this.week.controls.wednesday.value.forEach(element =>
    {
      l_result[2].push(element.start + ' - ' + element.end)
    });
    this.week.controls.thursday.value.forEach(element =>
    {
      l_result[3].push(element.start + ' - ' + element.end)
    });
    this.week.controls.friday.value.forEach(element =>
    {
      l_result[4].push(element.start + ' - ' + element.end)
    });
    this.week.controls.saturday.value.forEach(element =>
    {
      l_result[5].push(element.start + ' - ' + element.end)
    });
    this.week.controls.sunday.value.forEach(element =>
    {
      l_result[6].push(element.start + ' - ' + element.end)
    });

    l_result.forEach(l_day =>
    {
      if (l_day.length < 1)
      {
        l_day.push('closed')
      }
    })

    return l_result
  }

  onSubmit()
  {
    this.fillModel()
    this.dialogsManagerService.showReviewEditClinicOfficeDialogComponent()

  }

  isDisabledButton(): boolean
  {
    let l_disabled = false
    if ((!this.form.dirty && !this.dirty && !this.week.dirty) || !this.form.valid || !this.week.valid) l_disabled = true
    return l_disabled
  }

  openMap()
  {
    this.dialogsManagerService.showMapSelectionDialogComponent()
  }

  openDeleteClinicDialog()
  {
    this.dialogsManagerService.showDeleteClinicOfficeDialogComponent()
  }

  getFullCountryNameById(countryId: CountryId): CountriesEnum
  {
    return this.serverValueInterpreterService.getFullCountryNameById(countryId)
  }

  hasError(control: AbstractControl, controlName: string): boolean {
      if (!control || !(control instanceof FormGroup)) {
        return false;
      }
      const formControl = control.get(controlName);
      return !!(formControl && formControl.invalid && (formControl.dirty || formControl.touched));
    }
    
    /** ✅ New Method: Checks if any name in the FormArray has an error */
    hasAnyError(): boolean {
      return this.getEntNames().controls.some(group => this.hasError(group, 'firstName') || this.hasError(group, 'lastName'));
    }
}
